import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-select-with-search',
  templateUrl: './select-with-search.component.html',
  styleUrls: ['./select-with-search.component.css']
})
export class SelectWithSearchComponent implements OnInit {

  @Input() options: any;
  @Input() defaultSelect: any;
  @Input() disabled: boolean;
  @Input() bgColor: string;
  @Input() placeholder: string;
  @Output() selectionChange = new EventEmitter<string>();
  @Output() openDrop = new EventEmitter<string>();

  searchTerm: string = '';
  filteredOptions: any[] = [];


  selectedOption: any = '';
  showMyContainer: boolean = false;
  showClearFIlter: boolean = false;

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {

    if (changes.options) {
      this.filteredOptions = this.options;
    }
    if (changes.defaultSelect) {
      this.selectedOption = this.defaultSelect?.name;
    }
  }
  
  filterOptions() {
    this.filteredOptions = this.options.filter(option =>
      option.name.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }

  openDropdown() {
    this.showMyContainer = !this.showMyContainer;
    this.filteredOptions = this.options;
  }

  selectOption(option: any) {
    this.showMyContainer = false;
    this.searchTerm = '';
    if(option) {
      this.selectedOption =  option.name;
      this.showClearFIlter = true;
    } else {
      this.selectedOption = '';
      this.showClearFIlter = false;
    }
    this.selectionChange.emit(option);
    this.filteredOptions = [];
  }

}
